import { createSlice } from "@reduxjs/toolkit";
import { FirestoreService } from "../../api/firebase/firestoreService";
import { FirestoreDocumentReference } from "../../api/firebase/references";
import { HealthCareFacilityModel } from "../../data-model/healthFacility";
import {
  UserGeneralInfoContextKeys,
  UserStore,
} from "../../store/UserGeneralInfoStore";

export interface SingleHealthFacilitySliceModel {
  data?: HealthCareFacilityModel;
  loading: boolean;
  error: string | null;
}

const initialState: SingleHealthFacilitySliceModel = {
  data: undefined,
  loading: false,
  error: null,
};

const singleHealthFacilityDetailsSlice = createSlice({
  name: "singleHealthFacilityDetails",
  initialState,
  reducers: {
    fetchingSingleHealthFacilityDetails: (state) => {
      state.loading = true;
      state.error = null;
      state.data = undefined;
    },
    setHealthFacility: (state, action) => {
      state.data = action.payload;
      state.loading = false;
      state.error = null;
      // Mirror the facility name into UserStore so synchronous consumers
      // (e.g. Amplitude buildBaseEvent) can read org_name without an async fetch.
      const name = action.payload?.Name ?? "";
      if (name) {
        UserStore.setItem(UserGeneralInfoContextKeys.ORG_NAME, name);
      }
    },
    errorFetchingHealthFacility: (state, action) => {
      state.error = action.payload;
      state.loading = false;
      state.data = undefined;
    },
    resetHealthFacility: (state) => {
      state.data = undefined;
      state.loading = false;
      state.error = null;
    },
  },
});

export const {
  fetchingSingleHealthFacilityDetails,
  setHealthFacility,
  errorFetchingHealthFacility,
  resetHealthFacility,
} = singleHealthFacilityDetailsSlice.actions;

export const fetchSingleHealthFacilityDetailsFromFirebase =
  (facilityId: string) => async (dispatch) => {
    dispatch(fetchingSingleHealthFacilityDetails());
    try {
      const doc = await FirestoreService.getDocument<HealthCareFacilityModel>(
        FirestoreDocumentReference.healthFacility(facilityId),
      );

      dispatch(setHealthFacility(doc as HealthCareFacilityModel));
    } catch (error) {
      dispatch(errorFetchingHealthFacility(error as Error));
    }
  };

export default singleHealthFacilityDetailsSlice.reducer;
